/**
 * @generated SignedSource<<d90f0a718108bc46959ebf4fe21abeb1>>
 * @relayHash 561689ed4102f69a1d3aeb07b824e265
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b78b66a4dd4122f3ad0f6ed6bee86a5a71604683f52a0b53a44b11b7801c73c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceSettingsNavigationV1SpaceSettingsNavigationQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type SpaceSettingsNavigationV1SpaceSettingsNavigationQuery$data = {
  readonly space: {
    readonly alias: string | null | undefined;
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
  } | null | undefined;
  readonly webItemSections: ReadonlyArray<{
    readonly cacheKey: string | null | undefined;
    readonly id: string | null | undefined;
    readonly items: ReadonlyArray<{
      readonly completeKey: string | null | undefined;
      readonly icon: {
        readonly path: string;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly label: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined>;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type SpaceSettingsNavigationV1SpaceSettingsNavigationQuery = {
  response: SpaceSettingsNavigationV1SpaceSettingsNavigationQuery$data;
  variables: SpaceSettingsNavigationV1SpaceSettingsNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "key",
  "variableName": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "label"
},
v4 = [
  {
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "location",
        "value": "system.space.tools"
      }
    ],
    "concreteType": "WebSection",
    "kind": "LinkedField",
    "name": "webItemSections",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "cacheKey"
      },
      {
        "concreteType": "WebItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "completeKey"
          },
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceSettingsNavigationV1SpaceSettingsNavigationQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceSettingsNavigationV1SpaceSettingsNavigationQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "561689ed4102f69a1d3aeb07b824e265",
    "id": "7b78b66a4dd4122f3ad0f6ed6bee86a5a71604683f52a0b53a44b11b7801c73c",
    "metadata": {},
    "name": "SpaceSettingsNavigationV1SpaceSettingsNavigationQuery",
    "operationKind": "query",
    "text": "query SpaceSettingsNavigationV1SpaceSettingsNavigationQuery($spaceKey:String){webItemSections(location:\"system.space.tools\",key:$spaceKey){id,label,cacheKey,items{id,completeKey,label,url,icon{path}}},space(key:$spaceKey){alias,id,key,currentUser{isAdmin}}}"
  }
};
})();

(node as any).hash = "c624a190ca81d29c786ad57083ceac91";

export default node;
